import moment from 'moment'

interface ADHDProps {
  patient?: any,
  content?: any,
  logoUrl?: any,
  logoWidth?: any,
  logoHeight?: any,
  signUrl?: any,
  signWidth?: any,
  signHeight?: any,
  fullName?: any
}

const ADHDPreviewTemplate = ({ patient, content, logoUrl, logoHeight, fullName, logoWidth, signUrl, signHeight, signWidth }: ADHDProps) => {
  const displayAge = (dob: string) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    // Adjust age if the birthday hasn't occurred yet this year
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }

    return age;
  }

  return (
    <div className="d-flex flex-column gap-3 mt-2">
      <div className='w-100 d-flex justify-content-end'>
        {
          logoUrl && logoUrl !== "" && <img src={logoUrl} alt='logo' width={logoWidth} height={logoHeight} />
        }
      </div>
      <div className='w-100'>
        <div className="fw-bold">{moment().format("Do MMMM YYYY")}</div>
        <div className="mt-5">{`Dear Dr. ${content.docName || ""}`}</div>
        <div className="asdTemplate gap-3">
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Name:</span> {`${patient.first_Name} ${patient.last_Name}`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">DOB:</span> {patient.birthday}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Age:</span>{` ${displayAge(patient.birthday)} years old`}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Phone:</span>{patient?.phonenumber}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Address:</span>{patient?.address}</div>
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">School:</span>{patient?.school}</div>
          }
          {
            patient?.type === "child" && <div className="d-flex align-items-center gap-2"><span className="fw-bold">Parent:</span>{`${patient?.parent_firstname} ${patient?.parent_lastname}`}</div>
          }
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date of Report:</span>{moment(Date.now()).format("YYYY-MM-DD")}</div>
          <div className="d-flex align-items-center gap-2"><span className="fw-bold">Date Seen:</span>
            {content.dateSeen}
          </div>
        </div>
      </div>

      <div className="text-center w-100 fw-bold lh-lg mt-3">
        <div>Confidential Assessment Summary:</div>
        <div>Attention Deficit Hyperactivity Disorder (ADHD) - YOUNG DIVA 5:</div>
        <div>Diagnostic Interview for ADHD in young people (aged 5-17 years)</div>
      </div>
      <div>
        <div>{content.basic}</div>
        <div>We were able to successfully complete the Young DIVA-5 and it appears that she does meet the diagnosis see below:</div>
      </div>
      <div className="fw-bold lh-lg w-100">
        <div>{content.typeSelect}</div>
        <div>Severity - {content.severity}</div>
      </div>
      <div className="w-100">
        <table style={{ width: "70%", margin: '0 auto' }}>
          <tbody>
            <tr style={{ border: "1px solid" }}>
              <td className="text-center fw-bold" style={{ border: "1px solid" }}>DSM Criterion A<div>(symptoms of attention deflcit)</div></td>
              <td className="text-center fw-bold" style={{ border: "1px solid" }}>DSM Criterion A2 <div>(sysmptoms of hyperactivity-inpulsivity)</div></td>
              <td className="text-center fw-bold" style={{ border: "1px solid" }}>DSM Criterion B/C/D <div>(impairment on account of symptoms)</div></td>
            </tr>
            <tr style={{ border: "1px solid" }}>
              <td className="px-2 pt-3 text-center" style={{ border: "1px solid" }}>{content.dsmCreterionA}</td>
              <td className="px-2 pt-3 text-center" style={{ border: "1px solid" }}>{content.dsmCreterionA2}</td>
              <td className="px-2 pt-3 text-center" style={{ border: "1px solid" }}>{content.dsmCreterionBCD}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-5 w-100">
        <div className="fw-bold">Specific History Elicited Today:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.specificHistory && content.specificHistory.replace(/\n/g, '<br />') }}></div>
        <div className="mt-3">Social Skills and Emotional Regulation:</div>
        <div className='mt-1'>{content.socialSkills || ""}</div>
        <div className="mt-3">Sensory Processing Difficulties</div>
        <div className='mt-1'>{content.sensoryProcessing || ""}</div>
        <div className="mt-3">Strengths and Interests</div>
        <div className='mt-1'>{content.strength || ""}</div>
        <div className="mt-3">Contextual and Environmental Factors</div>
        <div className='mt-1'>{content.contextual || ""}</div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Developmental History:</div>
        <div className="fw-bold mt-2">Pregnancy and Birth:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.pregnancy && content.pregnancy.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Gross Motor Skills:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.grossMotor && content.grossMotor.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Fine Motor Skills:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.fineMotor && content.fineMotor.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Speech and Language Development:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.speechAndLanguage && content.speechAndLanguage.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Bedwetting and Soiling:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.betwetting && content.betwetting.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Report feedback:</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.reportSummary && content.reportSummary.replace(/\n/g, '<br />') }}></div>
      </div>
      <div className='mt-4'>
        <div className="fw-bold">Summary/Recommendations</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.recommendations && content.recommendations.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className='mt-4'>
        <div className="fw-bold">Other Recommendations</div>
        <div className='mt-1' dangerouslySetInnerHTML={{ __html: content.additionalRecommendations && content.additionalRecommendations.replace(/\n/g, '<br />') }}></div>
      </div>

      <div className="lh-lg fw-bold mt-5">
        <div>Kind regards,</div>
        <div className="mt-2">
          {
            signUrl && signUrl !== "" && <img src={signUrl} alt='logo' width={signWidth} height={signHeight} />
          }
        </div>
        <div className="mt-2">{fullName}</div>
        <div>Registered Psychologist</div>
      </div>
    </div>
  )
}

export default ADHDPreviewTemplate